import type { ISearchParams } from '../../interfaces/ISearchParams';

export class LoadSearchResults {
    static readonly type = '[Search Results] Load search results';

    constructor(
        public payload: {
            searchParams: ISearchParams;
            language: string;
        }
    ) {}
}

export class ClearSearchResults {
    static readonly type = '[Search Results] Clear search results';
}
